import { render, staticRenderFns } from "./gptDesign.vue?vue&type=template&id=7a746b41&scoped=true"
import script from "./gptDesign.vue?vue&type=script&lang=js"
export * from "./gptDesign.vue?vue&type=script&lang=js"
import style0 from "./gptDesign.vue?vue&type=style&index=0&id=7a746b41&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a746b41",
  null
  
)

export default component.exports